import * as React from 'react';

function SvgBtFileFilled(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" className="BtFileFilled_svg__icon" viewBox="0 0 1024 1024" {...props}>
      <defs>
        <style />
      </defs>
      <path d="M183.467 56.889h493.51l241.779 241.778v598.755c0 38.4-31.29 69.69-69.69 69.69H184.89c-38.4 0-69.689-31.29-69.689-69.69V128c-1.422-39.822 29.867-71.111 68.267-71.111z" />
      <path d="M918.756 298.667H748.089c-38.4 0-69.689-31.29-69.689-69.69V56.89l240.356 241.778z" />
      <path
        fill="#FFF"
        d="M476.444 487.822c15.645 5.69 28.445 14.222 36.978 25.6 8.534 11.378 12.8 24.178 12.8 39.822 0 21.334-7.11 39.823-22.755 54.045s-35.556 21.333-61.156 21.333H371.2v-256h52.622c27.022 0 46.934 5.69 61.156 17.067 14.222 11.378 21.333 27.022 21.333 46.933-1.422 22.756-11.378 39.822-29.867 51.2zm-76.8-9.955h11.378c21.334 0 36.978-2.845 46.934-9.956 9.955-7.111 15.644-17.067 15.644-31.289 0-22.755-15.644-34.133-48.356-34.133h-27.022v75.378zm0 122.31h28.445c18.489 0 31.289-1.421 38.4-5.688 8.533-2.845 14.222-8.533 19.911-15.645 4.267-7.11 7.111-14.222 7.111-22.755 0-7.111-1.422-14.222-4.267-19.911-2.844-5.69-7.11-11.378-12.8-15.645-5.688-4.266-12.8-7.11-21.333-9.955-8.533-2.845-22.755-2.845-44.089-2.845h-11.378v92.445zm287.29-197.688h-55.467v227.555H601.6V402.49h-55.467v-29.867h142.223v29.867z"
      />
    </svg>
  );
}

export default SvgBtFileFilled;
